import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useIntl } from "react-intl";
import languages from "../assets/languages";

import Drawer from "./Drawer";
import DrawerButton from "./DrawerButton";

// Helper to import all logo images using require.context (for CRA/Webpack)
const logoMap: Record<string, string> = {};
try {
	// @ts-ignore
	const req = require.context("../assets/logos", true, /logo\.png$/);
	req.keys().forEach((key: string) => {
		// key: './1/logo.png' => portal: '1'
		const match = key.match(/\.\/(\d+)\/logo\.png$/);
		if (match) {
			logoMap[match[1]] = req(key).default || req(key);
		}
	});
} catch {
	/* empty */
}

function Link(props: { to: string; className?: string; children: React.ReactNode }) {
	return (
		<a href={props.to} className={props.className}>
			{props.children}
		</a>
	);
}

export default function Header() {
	const { userData, logout } = useAuth();
	const intl = useIntl();
	const [drawerOpen, setDrawerOpen] = useState(false);

	const portal = userData?.user.portals.find((f) => f != 0);
	// Find the logo url for the current portal
	let logoUrl: string | undefined = undefined;
	if (portal && logoMap[portal]) {
		logoUrl = logoMap[portal];
	}

	return (
		<header
			className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-white container-fluid sticky-top"
			style={{ minHeight: 56, boxShadow: "0 2px 4px rgba(0,0,0,0.03)", zIndex: 1100 }}
		>
			{/* Left: Drawer button for mobile */}
			<div className="">
				<DrawerButton onClick={() => setDrawerOpen(true)} />
			</div>

			{/* Center: Logo or App Name */}
			<div className="d-flex align-items-center mx-auto mx-md-0">
				<div className="d-flex align-items-center">
					{logoUrl ? (
						<img
							src={logoUrl}
							alt="Logo"
							style={{ height: 32, width: "auto", objectFit: "contain" }}
							className="me-2"
						/>
					) : null}
				</div>
			</div>

			{/* Right: Navigation and User info (desktop only) */}
			<div className="d-none d-md-flex align-items-center gap-3">
				{/* Navigation link */}
				{userData ? (
					<>
						<Link to="/backoffice" className="btn btn-link text-decoration-none">
							Home
						</Link>
						<Link to="/backoffice/settings" className="btn btn-link text-decoration-none">
							Settings
						</Link>
					</>
				) : (
					<Link to="/" className="btn btn-link text-decoration-none">
						Home
					</Link>
				)}

				{/* User dropdown */}
				{/* {userData && (
					<div className="dropdown  d-lg-none">
						<button
							className="btn dropdown-toggle d-flex align-items-center"
							type="button"
							id="userDropdown"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<i className="bi bi-person-circle me-2" style={{ fontSize: 20 }}></i>
						</button>
						<ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
							<li>
								<span className="dropdown-item-text text-secondary small">
									{userData.user.username}
								</span>
							</li>
							<li>
								<hr className="dropdown-divider" />
							</li>
							<li>
								<button className="dropdown-item text-danger" onClick={logout}>
									{intl.formatMessage({ id: "logout" })}
								</button>
							</li>
						</ul>
					</div>
				)} */}

				{/* <div className="dropdown ms-2  d-lg-none">
					<button
						className="btn btn-light border dropdown-toggle d-flex align-items-center px-2 py-1"
						type="button"
						id="languageDropdown"
						data-bs-toggle="dropdown"
						aria-expanded="false"
						style={{ minWidth: 44, fontSize: 18 }}
					>
						<span className="me-1">
							{languages.find((l) => l.Code.startsWith(intl.locale))?.Icon || "🌐"}
						</span>
						<span className="d-none d-lg-inline" style={{ fontSize: 14, fontWeight: 500 }}>
							{languages.find((l) => l.Code.startsWith(intl.locale))?.Name}
						</span>
					</button>
					<ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
						{languages.map((lang) => (
							<li key={lang.LanguageId}>
								<button
									className={`dropdown-item d-flex align-items-center${lang.Code.startsWith(intl.locale) ? " fw-bold bg-light" : ""}`}
									style={{ fontSize: 15 }}
									onClick={() => window.location.assign(`/${lang.Code}`)}
									aria-current={lang.Code.startsWith(intl.locale) ? "true" : undefined}
								>
									<span className="me-2" style={{ fontSize: 18 }}>
										{lang.Icon}
									</span>
									{lang.Name}
								</button>
							</li>
						))}
					</ul>
				</div> */}
			</div>

			{/* Drawer for mobile */}
			<Drawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} onLogout={logout} />
		</header>
	);
}
